import styled from 'styled-components';

export const Text = styled.span`
  margin-bottom: 10px;
  text-align: center;
  font-size: 30px;
`;

export const ButtonWrapper = styled.span`
  margin-top: 20px;
`;

export const BoldText = styled.span`
  font-weight: 500;
  margin-bottom: 40px;
  font-size: 85px;
`;

export const Container = styled.div`
  z-index: 3;
  top: 0px;
  left: 0px;
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.palette.backgrounds.primary};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const TextWrapper = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 50px;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
`;
